import { NewsletterSubscription } from '../common/models/newsletters/newsletter-subscription.model';
import { NewslettersService } from '../services/newsletters.service';
import { GTMService } from '../services/gtm.service';
import { useIdentityStore } from '../stores/identity-store';
import { useSessionStore } from '../stores/SessionStorage';

export default function useNewsletterSubmit(newslettersService: NewslettersService | undefined, gtmService: GTMService | undefined): any {
    const errorMessage = 'We apologize, we were unable to complete your subscription at this time, please try again later.';
    const bestOfPatheosId = '57';

    const newsletterSubmit = async (listId: Array<string>, email: string, sourceDesc: string, partner: boolean, path: string) => {
        const sessionStore = useSessionStore();
        // get rsid from query parameter
        const rsid = sessionStore.rsid;

        // after we capture the email, update the identity store
        if (email) {
            const identity = useIdentityStore();
            identity.registerEmail(email).then(() => 'Identity Email Registration Complete');
        }
        
        if (newslettersService == undefined) {
            return { message: 'Failed to integrate with newsletter service', success: false };
        }
        // if nl id is set to -1, signup to postup is disabled
        if (!listId || listId.find(n => n == '-1')) {
            // still return true to falsely show that we signed up
            return { message: null, success: true };
        }

        // determine if list id 47 (Family Newsletter) is include and if so also include 57 (Best of Patheos)
        if (listId.find(n => n == '47')) {
            listId.push(bestOfPatheosId);
        }

        // first determine if we have a path url and if so let's go there
        if (path) {
            if (email && !rsid) {
                window.open(`${path}/step/2?email=${email}`, '_blank');
            } else if (email && rsid) {
                window.open(`${path}/step/2?email=${email}&rsid=${rsid}`, '_blank');
            } else {
                window.open(`${path}/step/2`, '_blank');
            }
        }

        const subscription: NewsletterSubscription = {
            email: email ?? '',
            name: '',
            newsletter: listId,
            sourceDesc: sourceDesc,
            partners: partner,
            rsid: rsid
        };

        try {
            const result = await newslettersService?.subscribe(subscription);

            if (result?.processed) {
                // GTM Form Tracking
                gtmService?.registerEvent('formNewsletterSuccess', {
                    formId: 'newsletter-signup-form-head'
                });

                return { message: null, success: true };
            }
        } catch (err) {
            return { message: errorMessage, success: false };
        }

        return { message: errorMessage, success: false };
    };

    return { newsletterSubmit };
}
